import { AxiosResponse } from 'axios';
import { SET_BANKS, SET_BANK, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_BANK_ISLOADING,
  DELETE_BANK,
  EDIT_BANK,
  GET_BANKS,
  GET_BANK,
  REGISTER_BANK,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Bank from '@/services/bank';
import { Module } from 'vuex';
import { EditBank, RegisterBank, GetBank } from '@/dtos/bank.dto';

const bank: Module<any, {}> = {
  state: {
    bank: {
      data: null,
      isLoading: false,
    },
    banks: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    bank: (state: { bank: any }) => state.bank,
    banks: (state: { banks: any }) => state.banks,
  },
  mutations: {
    [SET_BANK]: (
      state: { bank: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.bank.data = payload.data) : null,
        (state.bank.isLoading = payload.isLoading);
    },
    [SET_BANKS]: (
      state: { banks: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.banks.data = payload.data) : null,
        (state.banks.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_BANK]: async ({ commit }: any, payload: any) => {
      commit(SET_BANK, { data: null, isLoading: true });

      const result: AxiosResponse = await Bank.registerBank(
        payload as RegisterBank
      );

      if (result) {
        if (result.data.status) {
          commit(SET_BANK, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_BANK, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_BANK, { isLoading: false });
        return false;
      }
    },
    [GET_BANKS]: async ({ commit }: any, payload: any) => {
      commit(SET_BANKS, { data: null, isLoading: true });

      const result: AxiosResponse = await Bank.getBanks(
        payload as GetBank
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_BANKS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_BANKS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_BANKS, { isLoading: false });
        return false;
      }
    },
    [GET_BANK]: async ({ commit }: any, payload: any) => {
      commit(SET_BANK, { data: null, isLoading: true });

      const result: AxiosResponse = await Bank.getBanks(
        payload as GetBank
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_BANK, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_BANK, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_BANK, { isLoading: false });
        return false;
      }
    },
    [EDIT_BANK]: async ({ commit }: any, payload: any) => {
      commit(SET_BANK, { data: null, isLoading: true });

      const result: AxiosResponse = await Bank.editBank(
        payload as EditBank
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_BANK, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_BANK, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_BANK, { isLoading: false });
        return false;
      }
    },
    [DELETE_BANK]: async ({ commit }: any, payload: string) => {
      commit(SET_BANK, { data: null, isLoading: true });

      const result: AxiosResponse = await Bank.deleteBank(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_BANK, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_BANK, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_BANK, { isLoading: false });
        return false;
      }
    },
    [CLEAR_BANK_ISLOADING]: ({ commit }) => {
      commit(SET_BANK, { isLoading: false });
      commit(SET_BANKS, { isLoading: false });
    },
  },
};

export default bank;
